import React from 'react';

import IndependenceDay2025 from '../views/IndependenceDay2025';

const SchoolProgrampage = () => {
  return <IndependenceDay2025 />;
};

export default SchoolProgrampage;